import sanitizeHtml from 'sanitize-html';

export default function cleanHtml(theUncleanHTMLString) {
    return sanitizeHtml(
        theUncleanHTMLString,
        {
            allowedAttributes: {
                '*': ['href', 'align', 'alt', 'title', 'class']
            }
        }
    )
};


// WEBPACK FOOTER //
// ./src/app/utils/janitor.js